import { GroupedFloorPlan, Property } from '@greystar/lib/src/types/property-types';

export const RoomType = {
  bedroom: 'Bedrooms',
  bathroom: 'Bathrooms',
  studio: 'Studio',
};

export type FloorPlanFiltersProps = {
  setFilteredFloorPlans: (plans: GroupedFloorPlan[] | null) => void;
  groupedFloorPlans: GroupedFloorPlan[] | null;
  clearFiltersTrigger?: number;
  filterLabel?: string;
};

export type FilterParams = {
  groupedFloorPlans: GroupedFloorPlan[] | null;
  property: Property;
  min: number;
  max: number;
  minLease: number;
  maxLease: number;
  bedroomSelected: string[];
  bathroomSelected: string[];
  moveInSelected: string[];
};
